import { apiInstance } from '@shared/api'

const noCacheConfig = {
  headers: {
    'Cache-Control': 'no-cache, no-store, must-revalidate',
    Pragma: 'no-cache',
    Expires: '0',
  },
}

export const getBotList = async (params: BotListParams) => {
  const res = await apiInstance.get<BotListResponse>('/api/v1/bot/list', {
    ...noCacheConfig,
    params,
  })
  return res.data
}

// 전체 봇 조회 (symbol/side 쿼리 없음)
export const getAllBots = async () => {
  const res = await apiInstance.get<BotListResponse>('/api/v1/bot/list', noCacheConfig)
  return res.data
}

export const postBotStart = async (body: DCABotStartRequest) => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/bot/start', body)
  return res.data
}

export const postBotStop = async (body: BotStopRequest) => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/bot/stop', body)
  return res.data
}

export const postBotRepeatStop = async (body: BotStopRequest) => {
  const res = await apiInstance.post<ApiResponseBase>('/api/v1/bot/repeat-stop', body)
  return res.data
}
